import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom";
import { UserConsumer } from "../../Context/User-context";
import logo from "../../assets/imgs/logo.png";
import { getMainImg } from "../../Helper/Helper";
import "./index.css";
import axios from "../../axios-api";
import Loader from "../../components/UI/Loader/Loader";
import cartIcon from "./empty-cart.svg";

export default class StudentProfile extends Component {
  state = {
    student: {},
    isLoading: false,
    activeTab: "",
  };
  componentDidMount() {
    this.setState({ isLoading: true });
    axios
      .get(`/student/profile`)
      .then((res) => {
        this.setState({ student: res.data });
      })
      .catch((err) => console.log(err))
      .finally(() => this.setState({ isLoading: false }));
  }
  filterResults = (mode, type, e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    axios
      .get(`/student/profile?mode=${mode}&type=${type}`)
      .then((res) => {
        this.setState({ student: res?.data });
      })
      .catch((err) => console.log(err))
      .finally(() => this.setState({ isLoading: false }));
  };
  downloadCert = (file) => {
    var element = document.createElement("a");
    var blob = new Blob([file], { type: "image/*" });
    element.href = URL.createObjectURL(blob);
    element.download = "image.jpg";
    element.click();
  };
  render() {
    const { courses, exams, certs } = this.state.student;
    return (
      <UserConsumer>
        {(user) => (
          <>
            {this.state.isLoading === true ? <Loader /> : null}
            <Tabs>
              <div className="service_head pb-0">
                <div className="container-lg container-fluid">
                  <div className="text-center">
                    <img
                      className="rounded-circle"
                      src={getMainImg(user.logos)}
                      alt="صورة الحساب"
                      width="128"
                      height="128"
                    />
                    <h3 className="h6 medium_font mt-2 mb-3">{user.name}</h3>

                    <TabList
                      className="d-flex justify-content-center mt-4 student_tabs flex -nowrap"
                      style={{ overflowX: "auto", overflowY: "hidden" }}
                    >
                      <Tab>
                        <i className="fa fa-book ml-2"></i>
                        دوراتى
                      </Tab>
                      <Tab>
                        <i className="fa fa-file-image-o ml-2"></i>
                        شهاداتى
                      </Tab>
                      <Tab>
                        <i className="fa fa-edit ml-2"></i>
                        الواجبات
                      </Tab>
                      <Tab>
                        <i className="fa fa-users ml-2"></i>
                        منتدى النقاش
                      </Tab>
                      <Tab>
                        <i className="fa fa-star ml-2"></i>
                        الاختبارات
                      </Tab>
                      <Tab>
                        <i className="fa fa-black-tie ml-2"></i>
                        الوظائف
                      </Tab>
                    </TabList>
                  </div>
                </div>
              </div>

              <div className="container-lg container-fluid">
                <TabPanel className="tab_panel">
                  <ul className="nav sub_tabs">
                    <li className="nav-item active">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "course",
                          "all"
                        )}
                      >
                        <button className="nav-link active" aria-current="page">
                          الكل
                        </button>
                      </form>
                    </li>
                    <li className="nav-item">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "course",
                          "new"
                        )}
                      >
                        <button className="nav-link active" aria-current="page">
                          الدورات الحديثة
                        </button>
                      </form>
                    </li>
                    <li className="nav-item">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "course",
                          "done"
                        )}
                      >
                        <button className="nav-link " aria-current="page">
                          الدورات المنتهية
                        </button>
                      </form>
                    </li>
                    <li className="nav-item">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "course",
                          "random"
                        )}
                      >
                        <button className="nav-link" aria-current="page">
                          جديد دورات المنصة
                        </button>
                      </form>
                    </li>
                    <li className="nav-item">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "course",
                          "random"
                        )}
                      >
                        <button className="nav-link" aria-current="page">
                          المفضلة
                        </button>
                      </form>
                    </li>
                  </ul>
                  <div className="card p-3">
                    <div className="row">
                      {!courses?.length ? (
                        <NoResult
                          cartIcon={cartIcon}
                          msg="لايوجد دورات حتى الان"
                        />
                      ) : null}
                      {courses?.map((course, i) => {
                        return (
                          <div className="col-md-6 col-lg-4 mb-4" key={i}>
                            <Link to={`/course/${course.id}`}>
                              <div className="card">
                                <div className="card-header d-flex">
                                  <h3 className="medium_font h6">
                                    {course.title}
                                  </h3>
                                </div>
                                <div className="card-body">
                                  <img
                                    className={
                                      !course.image
                                        ? "transparent_img course_cover"
                                        : "course_cover"
                                    }
                                    src={course.image ? course.image : logo}
                                    alt={"دورة"}
                                  />
                                </div>
                                <div className="card-footer text-muted d-flex">
                                  <span className="d-flex align-items-center">
                                    <i className="fa fa-star text-warning ml-2"></i>
                                    <span>5</span>
                                  </span>
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </TabPanel>
                <TabPanel className="tab_panel">
                  <div className="card p-3">
                    {!certs?.length ? (
                      <NoResult
                        cartIcon={cartIcon}
                        msg="لايوجد شهادات حتى الان"
                      />
                    ) : null}
                    <div className="row">
                      {certs?.map((cert, i) => {
                        return (
                          <div className="col-md-6 col-lg-4 mb-4" key={i}>
                            <div className="card">
                              <Link to={`/course/${cert?.course.id}`}>
                                <div className="card-header d-flex">
                                  <h3 className="medium_font h6">
                                    {cert?.course.title}
                                  </h3>
                                </div>
                                <div className="card-body">
                                  <img
                                    className={
                                      !cert.image
                                        ? "transparent_img course_cover"
                                        : "course_cover"
                                    }
                                    src={cert.image ? cert.image : logo}
                                    alt={"دورة"}
                                  />
                                </div>
                              </Link>

                              <div className="card-footer text-muted d-flex">
                                {cert.certificate ? (
                                  <>
                                    <a
                                      href={cert.certificate}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-outline-dark ml-3 small_font"
                                    >
                                      <i className="fa fa-eye ml-2"></i>
                                      تحميل الشهادة
                                    </a>
                                    {/* <button
                                      onClick={() =>
                                        this.downloadCert(
                                          
                                        )
                                      }
                                      className="btn btn-dark small_font"
                                    >
                                      <i className="fa fa-download ml-2"></i>
                                      تحميل الشهادة
                                    </button> */}
                                  </>
                                ) : (
                                  "لايوجد شهادة فى هذه الدورة"
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </TabPanel>
                <TabPanel className="tab_panel">
                  <div className="card py-3">
                    <NoResult
                      cartIcon={cartIcon}
                      msg="لايوجد واجبات حتى الان"
                    />
                  </div>
                </TabPanel>
                <TabPanel className="tab_panel">
                  <div className="card py-3">
                    <NoResult
                      cartIcon={cartIcon}
                      msg="منتدى النقاش قيد التطوير"
                    />
                  </div>
                </TabPanel>
                <TabPanel className="tab_panel">
                  {!exams?.length ? (
                    <NoResult
                      cartIcon={cartIcon}
                      msg="لايوجد اختبارات حتى الان"
                    />
                  ) : null}
                  <ul className="nav sub_tabs">
                    <li className="nav-item">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "exam",
                          "active"
                        )}
                      >
                        <button className="nav-link active" aria-current="page">
                          الحالية
                        </button>
                      </form>
                    </li>
                    <li className="nav-item">
                      <form
                        onSubmit={this.filterResults.bind(
                          this,
                          "exam",
                          "disabled"
                        )}
                      >
                        <button className="nav-link active" aria-current="page">
                          المنتهية
                        </button>
                      </form>
                    </li>
                  </ul>
                  <div className="card p-3">
                    <div className="row">
                      {exams?.map((exam, i) => {
                        return (
                          <div className="col-md-6 col-lg-4 mb-4" key={i}>
                            <Link to={`/exam/${exam.id}`}>
                              <div className="card">
                                <div className="card-header d-flex">
                                  <h3 className="medium_font h6">
                                    {exam.title}
                                  </h3>
                                </div>
                                <div className="card-body">
                                  <img
                                    className={
                                      !exam.image
                                        ? "transparent_img course_cover"
                                        : "course_cover"
                                    }
                                    src={exam.image ? exam.image : logo}
                                    alt={"دورة"}
                                  />
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </TabPanel>
                <TabPanel className="tab_panel">
                  <div className="card py-3">
                    <NoResult cartIcon={cartIcon} msg="الوظائف قيد التطوير" />
                  </div>
                </TabPanel>
              </div>
            </Tabs>
          </>
        )}
      </UserConsumer>
    );
  }
}

function NoResult({ cartIcon, msg }) {
  return (
    <div className="text-center">
      <img
        style={{ opacity: 0.25, width: 84 }}
        src={cartIcon}
        alt="لايوجد نتائج"
        className="mb-3"
      />
      <h3 className="h5 grey medium_font mb-3">{msg}</h3>
    </div>
  );
}
